import { render } from "./second-block.vue?vue&type=template&id=673144b2&scoped=true"
import script from "./second-block.vue?vue&type=script&lang=js"
export * from "./second-block.vue?vue&type=script&lang=js"

import "./second-block.vue?vue&type=style&index=0&id=673144b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673144b2"]])

export default __exports__